import React from "react";
import "../Phone/Phone.scss";
const Phone = () => {
  return (
    <div className="phone">
      <div className="phone-background">
        <div className="bar">
          <div className="long"></div>
          <div className="short"></div>
        </div>
        <div className="bar">
          <div className="long"></div>
          <div className="short"></div>
        </div>
        <div className="bar purple">
          <div className="long"></div>
          <div className="short"></div>
        </div>
      </div>
    </div>
  );
};

export default Phone;
